// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__9nUot","Open":"SideDrawer_Open__jZQWZ","Close":"SideDrawer_Close__2Xyc0","Logo":"SideDrawer_Logo__1Czqi"};